import PaymentOption from 'checkout/enums/PaymentOption'

export const paymentOptionDisplayMap = new Map([
  [PaymentOption.AfterPay, 'AfterPay'],
  [PaymentOption.Affirm, 'Affirm'],
  [PaymentOption.PayPal, 'PayPal'],
  [PaymentOption.PayPalv2, 'PayPal'],
  [PaymentOption.Klarna, 'Klarna'],
])
